<template>
	<div class="container" v-loading.fullscreen.lock="fullscreenLoading">
		<Header @custom-event="getToken"></Header>
		<div class="page_content">
			
			<!--全部评论-开始-->
			<el-dialog
			  title="用戶點評"
			  :visible.sync="commentsDialog"
			  :destroy-on-close="true"
			  width="50%">
			  <div class="starlist_group">
			  	<div class="item" v-for="(item, index) in commentsList" :key="index">
			  		<div class="ud_star">
			  			<div class="ud">
			  				<h3>{{item.NickName}}</h3>
			  				<p class="date">發佈於 {{item.PostDate}}</p>
			  			</div>
			  			<div class="star_group">
			  				<div :class="getListStarClass(item.Star)"></div>
			  			</div>
			  		</div>
			  		<div class="u_post" v-html="item.Content">
			  		</div>
			  		<div class="op_reply" v-if="item.Reply !=''">
			  			<h3>管理員回覆：</h3>
			  			<div v-html="item.Reply"></div>
			  		</div>
			  	</div>
			  </div>
			</el-dialog>
			<!--全部评论-结束-->
			
			<!--全部图片-开始-->
			<el-dialog
			  title="图库"
			  :visible.sync="gallerysDialog"
			  :fullscreen="true"
			  custom-class="gallerysDialog"
			  >
			  <div class="gallerys_box" v-if="Gallerys.length>0">
				  <div class="left_items">
					  <div class="thumb">
					  	<ul>
					  		<li class="selected" v-if="index == galleryIndex" v-for="(item, index) in Gallerys" :key="index" @click="changeGallery(index)">
					  			<img :src="item.Picture" />
					  		</li>
					  		<li v-else @click="changeGallery(index)">
					  			<img :src="item.Picture" />
					  		</li>
					  	</ul>
					  </div>
				  </div>
				  <div class="right_preview">
					  <transition name="fade"><img v-if="showImage" :src="Gallerys[galleryIndex].Picture" /></transition>
				  </div>
			  </div>
			</el-dialog>
			<!--全部图片-结束-->
			
			<!--面包屑与公共提醒-开始-->
			<div class="ext_head">
				<div class="bread_crumb">
					<a href="/tw/">首頁</a><span class="space">/</span><a href="/tw/hotel">酒店</a><span class="space">/</span>{{hotelDetail.Title}}
				</div>
			</div>
			<!--面包屑与公共提醒-结束-->
			
			<!--图片区-开始-->
			<div class="pub_div dp_picture_box">
				<div class="focus_box">
					<div class="view_more" @click.stop="viewAllPictures()">更多圖片</div>
					<el-image
					style="width: 100%; height: 372px; border-radius: 8px;"
					:src="focusPicture"
					fit="cover"></el-image>
				</div>
				<div class="other_box">
					<div class="item" v-for="(item, index) in otherPictureList" :key="index">
						<el-image
						style="width: 100%; height: 180px; border-radius: 8px;"
						:src="item"
						fit="cover"></el-image>
					</div>
				</div>
			</div>
			<!--图片区-结束-->
			
			<!--Tab控制栏-开始-->
			<div class="sticky_box">
			<div class="pub_div tab_ctroller_box">
				
				<div class="tab_box">
					
					<el-tabs v-model="activeTab" stretch @tab-click="handleTabClick">
						<el-tab-pane v-for="item in tabList" :key="item.id" :label="item.label" :name="item.id" />
					</el-tabs>
					
				</div>
				
				<div class="favorite_box">
					<span v-if="CollectionState == 0" @click="collectionHandle(1)">收藏</span>
					<span class="selected" v-if="CollectionState == 1" @click="collectionHandle(0)">取消收藏</span>
				</div>
				
			</div>
			</div>
			<!--Tab控制栏-结束-->
			
			<!--基础信息-开始-->
			<div class="pub_div basic_information_box" id="tab1">
				
				<!--左侧-开始-->
				<div class="left_box">
					<h1>{{hotelDetail.Title}}</h1>
					<div class="ext_box">
						<span class="location">{{hotelDetail.Location}}</span>
						<span>{{hotelDetail.Address}}</span>
					</div>
					<!--属性-开始-->
					<div class="attribute">
						<div v-if="hotelDetail.StarPicture !=''" :class="'star h_s_'+hotelDetail.StarPicture"></div>
						<div class="tag brand" v-if="hotelDetail.BrandLocation !='其他'">{{hotelDetail.BrandLocation}}</div>
						<div class="tag baggage" v-if="hotelDetail.Baggage == '包含'">{{hotelDetail.Baggage}}行李費</div>
						<div class="tag sale">折扣優惠</div>
					</div>
					<!--属性-结束-->
					<!--摘要-开始-->
					<div class="description" v-if="hotelDetail.SubTitle != ''" v-html="hotelDetail.SubTitle"></div>
					<!--摘要-结束-->
					
					<!--房型-开始-->
					<div class="roomtype_box">
						<h3>請選擇房型</h3>
						<ul>
							<li v-for="(item, index) in roomTypeList" :key="index">
								<div class="type_title">
									<h4>{{item.Title}}</h4>
								</div>
								<div class="price_box">
									<div class="discount">${{item.SingleDiscountPrice}}<em>起</em></div>
									<div class="tips">該價格已包含度假村費</div>
								</div>
								<div class="btn_box" @click="booking(Id,item.RoomType)">預訂</div>
							</li>
						</ul>
					</div>
					<!--房型-结束-->
				</div>
				<!--左侧-结束-->
				
				<!--评论区-开始-->
				<div class="right_box">
					<!-- <Pinglun :Comments="hotelDetail.Comments" @custom-event="viewAllComments"></Pinglun> -->
										
					<!--友情提醒-开始-->
					<div class="prompt_box">
						<div class="icon djc"></div>
						<div class="text">
							<h5>什麼是度假村費？</h5>
							<p>美國夏威夷轄區內所有酒店向遊客強制收取的服務費用。</p>
						</div>
					</div>
					<!--友情提醒-结束-->
				</div>
				<!--评论区-结束-->
				
			</div>			
			<!--基础信息-结束-->
			
			<!--详细内容等富文本内容-开始-->
			<div class="html_content_box">
				<div class="html_section" id="tab2">
					<div class="title">酒店介紹</div>
					<div class="hs_content" v-html="hotelContent"></div>
				</div>
				<div class="html_section" id="tab3">
					<div class="title">預訂須知</div>
					<div class="hs_content" v-html="hotelDetail.Content"></div>
				</div>
				<div class="html_section" id="tab4">
					<div class="title">配套設施</div>
					<div class="hs_content">
						<ul class="facilities_box">
							<li v-for="(item, index) in hotelDetail.Facilities" :key="index">{{item.Title}}</li>
						</ul>
					</div>
				</div>
				<div class="html_section" id="tab5">
					<div class="title">接送地點</div>
					<div class="hs_content">
						<div class="collection_place">
							<div class="tips">{{collectionPlace.Tips}}</div>
							<div class="picture"><img :src="collectionPlace.Picture" /></div>
						</div>
					</div>
				</div>
			</div>
			<!--详细内容等富文本内容-结束-->
			
		</div>
		<Footer></Footer>
	</div>
</template>


<script>
	const TAB_OFFSET_TOP = 80;	//块内容距顶部距离
	
	import {
		getHotelDetail,
		checkToken,
		collection,
		getAllComments,
	} from '@/api/index.js'
	import {
		mixin
	} from '@/utils/mixin.js'
	import Header from '@/components/tw_header.vue'
	import Footer from '@/components/tw_footer.vue'
	import Pinglun from '@/components/tw_pinglun.vue'
	export default {
		name: 'TW_HotelDetail',
		mixins: [mixin],
		components: {
			Header,
			Footer,
			Pinglun,
		},
		data() {
			return {
				Id: '', //酒店Id
				fullscreenLoading: true, //loading状态
				language: 'tw', //语言版本
				terminal: 'pc', //终端，pc
				loginStatus: false,	//登录态
				token: null, //token
				hotelDetail: {}, //详情
				roomTypeList: [],	//房型列表
				Gallerys:[],		//图片集
				pictureIndex: 0,	//大图索引,
				galleryIndex: 0,	//大图索引,
				showImage: false,	//大图显示状态
				CollectionState:'',	//收藏状态
				clickLock: false,	//操作锁定状态,
				commentsDialog: false,	//全部评论展示状态
				commentsList:[],		//全部评论数据
				gallerysDialog: false,	//图库展示状态
				
				hotelContent: '',		//酒店介绍富文本
				
				//图片
				focusPicture: '',		//首图
				otherPictureList: [],	//后四张图
				
				//接送地点
				collectionPlace: {},
				
				// Tab标题栏相关
				activeTab: "tab1",
				isAutoScrolling: false,
				scrollTimer: null,
				tabList: [{
						id: "tab1",
						label: "酒店資訊",
					},
					{
						id: "tab2",
						label: "酒店介紹",
					},
					{
						id: "tab3",
						label: "預訂須知",
					},
					{
						id: "tab4",
						label: "配套設施",
					},
					{
						id: "tab5",
						label: "接送地點",
					},
				],
			}
		},
		computed: {
			limitedGallerys() {
				return this.hotelDetail.Gallerys.slice(0, 5); // 只取前5个元素
			}
		},
		mounted() {
			/*Tab标题栏使用*/
			this.$nextTick(() => {
				this.updateActiveTab();
				window.addEventListener("scroll", this.handleScroll, {
					passive: true
				});
				window.addEventListener("resize", this.handleScroll);
			});	
		},
		beforeDestroy() {
			/*Tab标题栏使用*/
			window.removeEventListener("scroll", this.handleScroll);
			window.removeEventListener("resize", this.handleScroll);
			if (this.scrollTimer) {
				clearTimeout(this.scrollTimer);
			}
		},
		created() {
			// 模拟获取url参数
			this.Id = this.$route.query.Id
		},
		methods: {
			//接收组件回传Token
			getToken(token)
			{
				this.token = token
				if(this.token !=null && this.token !='')
				{
					this.loginStatus = true
				}
				this.getData()
			},
			
			//获取数据
			async getData() {
				const {
					data: res
				} = await getHotelDetail(this.language, this.terminal, this.Id, this.token)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.hotelDetail = res.data
					document.title = this.hotelDetail.Title + ' | 酒店 - 檀島旅遊 (繁體中文)'
					this.Gallerys = res.data.Gallerys
					this.showImage = true
					this.CollectionState = this.hotelDetail.CollectionState
					this.roomTypeList = this.hotelDetail.RoomTypes
					
					//热词替换
					this.hotelContent = this.patchReplace(
					this.hotelDetail.RecreationHotKeywords,
					this.hotelDetail.Detailed,
					'/tw/recreation/detail?Id=')
					
					//新增图片解析
					this.pictureFilter(this.Gallerys)
					
					//接送地点
					this.collectionPlace = this.hotelDetail.CollectionPlace
					
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//切换图片
			changeGallery(i)
			{
				if(this.galleryIndex != i)
				{
					this.showImage = false
					this.galleryIndex = i
					setTimeout(() => {
						this.showImage = true
					}, 100)
				}
			},
			
			//收藏操作
			async collectionHandle(action)
			{
				if(this.clickLock)
				{
					return
				}
				this.clickLock = true	//锁住按钮
				if(this.loginStatus)
				{
					let params={
						Token:this.token,
						Terminal:this.terminal,
						ColumnId:2,
						Id:this.Id,
						Action:action
					}
					const { data: res } = await collection(params)
					if (res.errcode === 0) {						
						this.CollectionState = action
						this.$message({
						  message: '操作成功',
						  type: 'success'
						});
					} else {
						this.$message.error(res.errmsg);
					}
				}
				else
				{
					this.$router.push({
						path: '/tw/user/login?ReturnUrl=' + encodeURIComponent(window.location.href)
					})
				}
				this.clickLock = false	//解锁按钮
			},
			
			//图片解析处理
			pictureFilter(gallerys)
			{
				if(gallerys.length>0)
				{
					this.focusPicture = gallerys[0].Picture
					
					gallerys.forEach((item, index) => {
						if(index > 0 && index < 5)
						{
							this.otherPictureList.push(gallerys[index].Picture)
						}
					})
				}
			},
			
			//立即预订
			booking(Id,roomType)
			{
				// this.$router.push({
				// 	path: '/tw/hotel/booking?Id='+this.Id+'&RoomType=' + roomType
				// })
				location.href = '/tw/hotel/booking?Id='+this.Id+'&RoomType=' + roomType
			},
			
			//查看全部评论
			viewAllComments()
			{
				this.getAllComments()
			},
			
			//获取全部评论数据
			async getAllComments()
			{
				this.fullscreenLoading = true
				let params={
					PageIndex: 1,
					ColumnId: 2,
					DataId: this.Id,
				}				
				const { data: res } = await getAllComments(params.PageIndex, params.ColumnId, params.DataId)
				this.fullscreenLoading = false
				if (res.errcode === 0) {
					this.commentsList = res.data.DataList
					this.commentsDialog = true
				} else {
					this.$message.error(res.errmsg);
				}
			},
			
			//查看全部图片
			viewAllPictures()
			{
				this.galleryIndex = 0
				this.gallerysDialog = true
			},
			
			/*以下为Tab栏使用的方法*/
			handleTabClick(tab) {
				this.scrollToContent(tab.name);
			},
			handleScroll() {
				if (this.isAutoScrolling) {
					return;
				}
				this.updateActiveTab();
			},
			scrollToContent(id) {
				const target = document.getElementById(id);
				if (!target) {
					return;
				}
			
				this.activeTab = id;
				this.isAutoScrolling = true;
				window.scrollTo({
					top: target.offsetTop - TAB_OFFSET_TOP,
					behavior: "smooth",
				});
			
				if (this.scrollTimer) {
					clearTimeout(this.scrollTimer);
				}
				this.scrollTimer = setTimeout(() => {
					this.isAutoScrolling = false;
					this.updateActiveTab();
				}, 500);
			},
			updateActiveTab() {
				const threshold = TAB_OFFSET_TOP + 20;
				let currentId = this.tabList[0].id;
			
				this.tabList.forEach((item) => {
					const element = document.getElementById(item.id);
					if (element && element.getBoundingClientRect().top <= threshold) {
						currentId = item.id;
					}
				});
			
				if (
					window.innerHeight + window.pageYOffset >=
					document.documentElement.scrollHeight - 10
				) {
					currentId = this.tabList[this.tabList.length - 1].id;
				}
			
				this.activeTab = currentId;
			},
		}
	}
</script>

<style lang="less" scoped>
	.container {
		width: 100%;
		box-sizing: border-box;
		
		/*配套设施*/
		.facilities_box {
			display: flex;
			justify-content: flex-start;
			flex-wrap: wrap;
			
			li {
				width: 25%;
				box-sizing: border-box;
				font-size: 14px;
				line-height: 26px;
				margin: 5px 0;
				padding-left: 20px;
				background-position: left center;
				background-repeat: no-repeat;
				background-image: url(@/assets/images/icons/d_selected.png);
				background-size: 16px 16px;
			}
		}
		
		/*接送地址*/
		.collection_place {
			.tips {
				font-size: 15px;
				margin-bottom: 10px;
			}
			
			.picture {
				width: 100%;
				position: relative;
				overflow: hidden;
				
				image {
					max-width: 100%;
				}
			}
		}
		
		/*房型*/
		.roomtype_box {
			margin-top: 30px;
			
			h3 {
				font-size: 18px;
				font-weight: 500;
			}
			
			ul {
				margin-top: 20px;
			}
			li {
				background-color: #fff;
				border: #E4E4E4 solid 2px;
				border-radius: 8px;
				padding: 12px;
				margin: 10px 0;
				-webkit-transition: all .3s ease;
				display: flex;
				justify-content: space-between;
				align-items: center;
				background-color: #FAFFF9;
				
				.type_title {
					width: 60%;
					h4 {
						font-size: 16px;
						font-weight: 500;
					}
				}
				
				.price_box {
					width: 20%;
					text-align: right;
					
					.discount {
						font-size: 24px;
						font-weight: 500;
						
						em {
							display: inline-block;
							font-size: 13px;
							color: #333;
							vertical-align: middle;
							margin-left: 4px;
							font-size: 400;
						}
					}
					.tips {
						margin-top: 6px;
						font-size: 12px;
						font-weight: 500;
						line-height: 100%;
						color: #3D7856;
						text-align: right;
					}
				}
				
				.btn_box {
					width: 80px;
					height: 40px;
					line-height: 40px;
					background-color: #3D7856;
					border-radius: 20px;
					color: #fff;
					font-size: 15px;
					text-align: center;
					cursor: pointer;
					-webkit-transition: all .3s ease;
				}
				.btn_box:hover {
					background-color: #000;
				}
			}
			li:hover {
				border: #3D7856 solid 2px;
				background-color: #FAFFF9;
			}
		}
	}
</style>